module.exports = __webpack_public_path__ + "img/00024.2cdba8b3.webp";